<template>
  <v-layout justify-center>
    <v-flex xs12 sm10 md10>
      <v-layout
        justify-space-between
        pa-3
      >
        <v-flex xs5>
          <v-treeview
            :active.sync="active"
            :open.sync="open"
            :items="documents"
            activatable
            item-key="id"
            open-on-click
            @update:active="viewDoc"
            transition
          >
            <template v-slot:prepend="{ item, active }">
              <v-icon v-if="!item.file">
                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
              </v-icon>
              <v-icon v-else-if="fileTypes[item.file].color" :color="fileTypes[item.file].color">
                {{ fileTypes[item.file].icon }}
              </v-icon>
              <v-icon v-else>
                mdi-file-document-outline
              </v-icon>
            </template>
          </v-treeview>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-btn
      fab
      bottom
      right
      color="blue"
      dark
      fixed
      class="add-button-bottom"
      @click.stop="openForm"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog
      v-model="dialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add/Edit Document</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn v-if="editDocument.id > 0" dark flat @click="save()">Update</v-btn>
          <v-btn v-else dark flat @click="save()">Save</v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="editDocument.name"
                  @keyup.enter="save"
                  label="Document Name"
                  v-validate="'required'"
                  :error-messages="errors.collect('name')"
                  data-vv-name="name"
                ></v-text-field>
              </v-flex>
              <v-flex v-if="files.length === 0 && !editDocument.id" xs12>
                <v-btn color="blue darken-1" flat v-on:click="addFiles()">
                  <v-icon left dark>mdi-paperclip</v-icon>
                  Add Document
                </v-btn>
              </v-flex>
              <v-flex v-if="files.length === 0 && !editDocument.id" xs12>
                <label>
                  <input type="file" id="files" ref="files" multiple v-on:change="handleFileUploads"/>
                </label>
              </v-flex>
              <v-flex xs12>
                <v-list two-line subheader>
                  <v-subheader v-if="files.length > 0" inset>File</v-subheader>
                  <v-divider v-if="files.length > 0"></v-divider>
                  <template v-for="(file, index) in files">
                    <v-list-tile avatar :key="index">
                      <v-list-tile-avatar>
                        <v-icon
                          v-if="file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/excel' || file.type === 'text/csv'"
                          color="green darken-2"
                          large
                        >
                          mdi-file-excel
                        </v-icon>
                        <v-icon
                          v-else-if="file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type === 'application/msword'"
                          color="blue darken-2"
                          large
                        >
                          mdi-file-word
                        </v-icon>
                        <v-icon
                          v-else-if="file.type === 'image/png' || file.type === 'image/jpeg'"
                          color="yellow darken-2"
                          large
                        >
                          mdi-file-image
                        </v-icon>
                        <v-icon
                          v-else-if="file.type === 'application/pdf'"
                          color="red darken-2"
                          large
                        >
                          mdi-file-pdf
                        </v-icon>
                        <v-icon
                          v-else-if="file.type === 'application/zip'"
                          color="orange darken-2"
                          large
                        >
                          mdi-zip-box
                        </v-icon>
                        <v-icon
                          v-else
                          color="gray darken-2"
                          large
                        >
                          mdi-file-document-box
                        </v-icon>
                      </v-list-tile-avatar>

                      <v-list-tile-content inset>
                        <v-list-tile-title>{{ file.name }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ file.lastModified }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon v-on:click="removeFile( index )" color="red">block</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider :key="file.name"></v-divider>
                  </template>
                </v-list>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  :items="committeeList"
                  v-model="editDocument.committee"
                  item-text="text"
                  item-value="text"
                  label="Folder"
                  hide-details
                  @keyup.enter="save"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="editDocument.notes"
                  label="Notes"
                  prepend-icon="notes"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogShow"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Document View</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items v-if="canEdit">
            <v-menu offset-y>
            <v-btn slot="activator" icon dark>
              <v-icon>more_vert</v-icon>
            </v-btn>
            <v-list dense>
              <v-list-tile @click.stop="editItem">
                <v-list-tile-action>
                <v-icon color="primary">build</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="indigo--text">Edit</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click.stop="deleteDocument(selected.id)">
                <v-list-tile-action>
                <v-icon color="red">delete</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="red--text">Delete</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap text-xs-center>
              <v-flex xs12>
                <v-card
                  v-if="selected"
                  :key="selected.id"
                  class="pt-4 mx-auto"
                  flat
                >
                  <v-card-text>
                    <v-layout row wrap text-xs-center>
                      <v-flex xs12 sm6 md4>
                        <v-avatar
                          size="80"
                        >
                          <v-img
                            :src="selected.User.picture"
                            class="mb-4"
                          ></v-img>
                        </v-avatar>

                        <h4 class="mb-2">
                          {{ selected.User.fullName }}
                        </h4>
                      </v-flex>
                      <v-divider></v-divider>
                      <v-flex xs12 sm6 md8>
                        <h3 class="headline mb-2">
                          {{ selected.name }}
                        </h3>
                        <div v-if="selected.committee">
                          ({{ selected.committee }})
                        </div>
                        <div class="pt-3">
                          <v-icon :color="fileTypes[selected.fileExt].color">
                            {{ fileTypes[selected.fileExt].icon }}
                          </v-icon>
                          This is a {{ fileTypes[selected.fileExt].type }}
                        </div>
                      </v-flex>
                      <v-flex v-if="selected.notes" class="pt-3" xs12>
                        <strong>Notes:</strong> {{ selected.notes }}
                      </v-flex>
                      <v-flex xs12 text-xs-right>
                        <v-divider></v-divider>
                        <v-btn :href="selected.filePath" target="_blank" color="primary">Download</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'

export default {
  data: () => ({
    currentPage: 'Documents',
    userId: 0,
    // myId: this.$store.state.user.id,
    isAdmin: false,
    canEdit: false,
    committeeList: [],
    editDocument: {},
    dialog: false,
    dialogShow: false,
    active: [],
    open: [],
    fileTypes: {
      pdf: {
        icon: 'mdi-file-pdf',
        type: 'PDF',
        color: 'red darken-2'
      },
      png: {
        icon: 'mdi-file-image',
        type: 'PNG Image',
        color: 'yellow darken-2'
      },
      jpg: {
        icon: 'mdi-file-image',
        type: 'JPG Image',
        color: 'yellow darken-2'
      },
      jpeg: {
        icon: 'mdi-file-image',
        type: 'JPG Image',
        color: 'yellow darken-2'
      },
      txt: {
        icon: 'mdi-file-document-outline',
        type: 'Text Document',
        color: 'gray darken-2'
      },
      xls: {
        icon: 'mdi-file-excel',
        type: 'Excel Document',
        color: 'green darken-2'
      },
      xlsx: {
        icon: 'mdi-file-excel',
        type: 'Excel Document',
        color: 'green darken-2'
      },
      doc: {
        icon: 'mdi-file-word',
        type: 'Word Document',
        color: 'blue darken-2'
      },
      docx: {
        icon: 'mdi-file-word',
        type: 'Word Document',
        color: 'blue darken-2'
      }
    },
    tree: [],
    documents: [],
    items: [],
    files: []
  }),

  created () {
    this.$store.dispatch('setCurrentPage', this.currentPage)
    this.currentYear = this.$store.state.currentYear
    this.isAdmin = this.$store.state.isAdmin
    this.userId = this.$store.state.user.id

    this.getDocuments()
    this.getCommitteeItems()
  },

  computed: {
    selected () {
      if (!this.active.length) return undefined

      const id = this.active[0]

      return this.items.find(item => item.id === id)
    },

    filter () {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined
    }
  },

  methods: {
    addFiles () {
      this.$refs.files.click()
    },

    handleFileUploads (e) {
      let uploadedFiles = e.target.files

      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i])
      }
    },

    removeFile (key) {
      this.files.splice(key, 1)
    },

    viewDoc () {
      if (this.active.length > 0) {
        if (this.selected.userId === this.userId) {
          this.canEdit = true
        } else if (this.isAdmin === true) {
          this.canEdit = true
        } else {
          this.canEdit = false
        }

        this.dialogShow = true
      }
    },

    openForm () {
      this.dialog = true
    },

    editItem () {
      this.editDocument = this.selected
      this.dialogShow = false
      this.dialog = true
    },

    async getCommitteeItems () {
      try {
        const response = await Api().get('active_folders/')
        this.committeeList = response.data
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getDocuments () {
      try {
        const response = await Api().get('get_documents')
        const documents = response.data
        this.items = response.data
        let prevCommittee = ''
        let children = []

        for (let i = 0; i < documents.length; i++) {
          let committee = documents[i].committee

          if (committee) {
            console.log(committee)
            let documentItem = {
              name: committee,
              children: []
            }

            if (committee !== prevCommittee) {
              // documentItem.name = prevCommittee
              this.documents.push(documentItem)
              children = []
              // console.log(documents[i].name)
              let subItem = {
                id: documents[i].id,
                name: documents[i].name,
                file: documents[i].fileExt
              }

              children.push(subItem)
              console.log('1', children)
              documentItem.children = children
            } else {
              // console.log(documents[i].name)
              let subItem = {
                id: documents[i].id,
                name: documents[i].name,
                file: documents[i].fileExt
              }
              children.push(subItem)
              console.log('2', children)
            }
          } else {
            let documentItem = {
              id: documents[i].id,
              name: documents[i].name,
              file: documents[i].fileExt
            }

            this.documents.push(documentItem)
          }

          prevCommittee = committee
        }

        console.log(this.documents)
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    save () {
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.saving = false
          this.snackbar.message = 'There were errors in the form'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        } else {
          if (!this.editDocument.committee) {
            this.editDocument.committee = ''
          }

          if (!this.editDocument.notes) {
            this.editDocument.notes = ''
          }

          if (this.editDocument.id > 0) {
            this.updateItem()
          } else {
            this.addItem()
          }
        }
      })
    },

    async addItem () {
      let filenames = []

      let formData = new FormData()
      formData.append('name', this.editDocument.name)
      formData.append('committee', this.editDocument.committee)
      formData.append('notes', this.editDocument.notes)
      formData.append('UserId', this.userId)

      for (var i = 0; i < this.files.length; i++) {
        formData.append('files', this.files[i])
        filenames.push(this.files[i].name)
      }

      formData.append('files', filenames)
      formData.append('fileName', filenames)

      try {
        const response = await Api().post('documents', formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })

        this.documents = []
        this.getDocuments()
        this.dialog = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem () {
      try {
        this.editDocument.UserId = this.userId

        const response = await Api().put('documents/' + this.editDocument.id, this.editDocument)

        this.documents = []
        this.getDocuments()
        this.dialog = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async deleteDocument (documentId) {
      let r = confirm('Are you sure you want to remove this document?')

      if (r === true) {
        try {
          const response = await Api().delete('documents/' + documentId)

          this.documents = []
          this.getDocuments()
          this.dialogShow = false

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    close () {
      this.editDocument = {}

      this.dialog = false
      this.dialogShow = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/Document.vue